<template>
  <div>
    <div class="materials">
      <p v-if="isCategoryAdvanced" class="attention mb-0">※「例文問題」「反意語問題」にのみ適用されます。</p>
      <v-category-button v-for='material in materials'
        @click="setWordCategory(material.value)"
        :key="material.id"
        :type="material.type"
        :active="checkedList.includes(material.value[0])"
        :disabled="material.disabled"
      >
        {{material.text}}
      </v-category-button>
    </div>
  </div>
</template>

<script>
import VCategoryButton from '@/components/atoms/CategoryButton'
export default {

  components: {
    VCategoryButton
  },

  data: () => ({
  }),

  computed: {
    checkedList() {
      return this.$store.state.conditions.checkedArr['target']
    },
    isCategoryAdvanced() {
      return this.$store.getters['conditions/isCategoryAdvanced']
    },
    materials() {
      return [
        {id: 1, text: '単語', value: [1], type: 'tango'},
        {id: 2, text: '連語', value: [2], type: 'rengo'},
      ]
    },
  },

  methods: {
    setWordCategory(value) {
      this.$store.commit('conditions/setCheckList', {
          listName: 'target',
          value: value
      })
    }
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
.materials
  max-width 800px

.attention
  font-size 12px
</style>
